"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormikDevtools = exports.withFormikDevtools = void 0;
var extendedWindow = typeof window === 'undefined' ? null : window;
var FormikDevtools = function () {
    var isInitialRender = true;
    return function (formikProps, children) {
        if (extendedWindow === null || extendedWindow === void 0 ? void 0 : extendedWindow.FORMIK_DEVTOOLS) {
            extendedWindow.FORMIK_DEVTOOLS(__assign(__assign({}, formikProps), { __init: isInitialRender }));
            if (isInitialRender) {
                isInitialRender = false;
            }
        }
        return children;
    };
};
exports.withFormikDevtools = FormikDevtools();
var getNamedFormikDevtools = function (formName) {
    var isInitialRender = true;
    return function (formikProps, children) {
        if (extendedWindow === null || extendedWindow === void 0 ? void 0 : extendedWindow.FORMIK_DEVTOOLS) {
            extendedWindow.FORMIK_DEVTOOLS(__assign(__assign({}, formikProps), { __init: isInitialRender, __formName: formName }));
            if (isInitialRender) {
                isInitialRender = false;
            }
        }
        return children;
    };
};
exports.getFormikDevtools = getNamedFormikDevtools;
